module.exports = __webpack_public_path__ + "img/Flinto_George.5220d919.jpg";